// extracted by mini-css-extract-plugin
export var cardIcon = "_8x-5";
export var cardIconUnframed = "_8x-9";
export var checkboxCard = "_8x-0";
export var checkboxCardSelected = "_8x-4";
export var disabled = "_8x-2";
export var interactive = "_8x-1";
export var outerBorder = "_8x-3";
export var spacerMedium = "_8x-8";
export var spacerSmall = "_8x-7";
export var spacerXsmall = "_8x-6";